// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"367":"b536a0f1","413":"1329d575","432":"b468fba8"}[chunkId] || chunkId) + "." + {"325":"7521aaecf1041abc","367":"bee87fca3d52eca1","413":"38f9b21869d5bf93","432":"9099692bc68e43dd","795":"c73e3264621591b9"}[chunkId] + ".js";
};